'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _defaultProps = require('../default-props');

var _defaultProps2 = _interopRequireDefault(_defaultProps);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ElasticReverse = function (_React$Component) {
  (0, _inherits3["default"])(ElasticReverse, _React$Component);

  function ElasticReverse() {
    (0, _classCallCheck3["default"])(this, ElasticReverse);
    return (0, _possibleConstructorReturn3["default"])(this, (ElasticReverse.__proto__ || Object.getPrototypeOf(ElasticReverse)).apply(this, arguments));
  }

  (0, _createClass3["default"])(ElasticReverse, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          lineHeight = _props.lineHeight,
          lineSpacing = _props.lineSpacing;
      var yOffset = lineSpacing + lineHeight;
      return _react2["default"].createElement(_base2["default"], (0, _extends3["default"])({
        typeClassName: 'BurgerElasticReverse'
      }, this.props), _react2["default"].createElement(_style2["default"], {
        styleId: '772287595',
        css: '.BurgerElasticReverse .BurgerInner{top:lineHeight / 2;-webkit-transition-duration:0.275s;transition-duration:0.275s;-webkit-transition-timing-function:cubic-bezier(0.68,-0.55,0.265,1.55);transition-timing-function:cubic-bezier(0.68,-0.55,0.265,1.55);}.BurgerElasticReverse .BurgerInner:before{top:' + yOffset + 'px;-webkit-transition:opacity 0.125s 0.275s ease;transition:opacity 0.125s 0.275s ease;}.BurgerElasticReverse .BurgerInner:after{top:' + yOffset * 2 + 'px;-webkit-transition:-webkit-transform 0.275s cubic-bezier(0.68,-0.55,0.265,1.55);-webkit-transition:transform 0.275s cubic-bezier(0.68,-0.55,0.265,1.55);transition:transform 0.275s cubic-bezier(0.68,-0.55,0.265,1.55);}.BurgerElasticReverse.BurgerActive .BurgerInner{-webkit-transform:translate3d(0,' + yOffset + 'px,0) rotate(-135deg);-ms-transform:translate3d(0,' + yOffset + 'px,0) rotate(-135deg);transform:translate3d(0,' + yOffset + 'px,0) rotate(-135deg);-webkit-transition-delay:0.075s;transition-delay:0.075s;}.BurgerElasticReverse.BurgerActive .BurgerInner:before{-webkit-transition-delay:0s;transition-delay:0s;opacity:0;}.BurgerElasticReverse.BurgerActive .BurgerInner:after{-webkit-transform:translate3d(0,' + yOffset * -2 + 'px,0) rotate(270deg);-ms-transform:translate3d(0,' + yOffset * -2 + 'px,0) rotate(270deg);transform:translate3d(0,' + yOffset * -2 + 'px,0) rotate(270deg);-webkit-transition-delay:0.075s;transition-delay:0.075s;}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */\n/*@ sourceURL=../../src/types/elastic-reverse.js */',
        dynamic: [yOffset, yOffset * 2, yOffset, yOffset * -2]
      }));
    }
  }]);
  return ElasticReverse;
}(_react2["default"].Component);

exports["default"] = ElasticReverse;
ElasticReverse.defaultProps = _defaultProps2["default"];
module.exports = exports['default'];